import {
  ChangeDetectionStrategy,
  Component,
  Renderer2,
  ViewChild,
  computed,
  effect,
  inject,
} from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, fromEvent, map, Subscription } from 'rxjs';
import { AppTopbar } from './app.topbar';
import { AppSidebar } from './app.sidebar';
import { AppFooter } from './app.footer';
import { LayoutService } from '../service/layout.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [NgClass, AppTopbar, AppSidebar, RouterModule],
  template: `<div class="layout-wrapper" [ngClass]="containerClass()">
    <app-topbar></app-topbar>
    <app-sidebar></app-sidebar>
    <div class="layout-main-container">
      <div class="layout-main">
        <router-outlet></router-outlet>
        <router-outlet name="modal"></router-outlet>
      </div>
    </div>
    <div class="layout-mask animate-fadein"></div>
  </div> `,
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLayout {
  layoutService = inject(LayoutService);
  renderer = inject(Renderer2);
  router = inject(Router);

  // overlayMenuOpenSubscription: Subscription;

  menuOutsideClickListener: any;

  @ViewChild(AppSidebar) appSidebar!: AppSidebar;

  @ViewChild(AppTopbar) appTopBar!: AppTopbar;

  constructor() {
    if (!this.menuOutsideClickListener) {
      this.menuOutsideClickListener = this.renderer.listen(
        'document',
        'click',
        (event) => {
          if (this.isOutsideClicked(event)) {
            this.hideMenu();
          }
        }
      );
    }
    effect(() => {
      if (this.layoutService.layoutState().staticMenuMobileActive) {
        this.blockBodyScroll();
      }
    });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.hideMenu();
      });
  }

  isOutsideClicked(event: MouseEvent) {
    const sidebarEl = document.querySelector('.layout-sidebar');
    const topbarEl = document.querySelector('.layout-menu-button');
    const eventTarget = event.target as Node;

    return !(
      sidebarEl?.isSameNode(eventTarget) ||
      sidebarEl?.contains(eventTarget) ||
      topbarEl?.isSameNode(eventTarget) ||
      topbarEl?.contains(eventTarget)
    );
  }

  hideMenu() {
    this.layoutService.layoutState.update((prev) => ({
      ...prev,
      overlayMenuActive: false,
      staticMenuMobileActive: false,
      menuHoverActive: false,
    }));
    if (this.menuOutsideClickListener) {
      // this.menuOutsideClickListener(); // Remove the listener
      this.menuOutsideClickListener = null;
    }
    this.unblockBodyScroll();
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    } else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(
        new RegExp(
          '(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)',
          'gi'
        ),
        ' '
      );
    }
  }
  containerClass = computed(() => ({
    'layout-static': this.layoutService.layoutConfig().menuMode === 'static',
    'layout-static-inactive':
      this.layoutService.layoutState().staticMenuDesktopInactive &&
      this.layoutService.layoutConfig().menuMode === 'static',
    'layout-mobile-active':
      this.layoutService.layoutState().staticMenuMobileActive,
  }));

  ngOnDestroy() {
    if (this.menuOutsideClickListener) {
      this.menuOutsideClickListener(); // Remove the listener
      this.menuOutsideClickListener = null;
    }
  }
}
